export default __webpack_public_path__ + "static/media/Logo-celltrion.296e4197.svg";